import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { useSearchParams } from 'react-router-dom';

const LoginPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect') || '/';
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <SignIn path="/login" routing="path" signUpUrl="/sign-up" redirectUrl={redirect} afterSignInUrl={redirect} />
    </div>
  );
};

export default LoginPage; 